/**
   * Returns the decoded value of a cookie by name.
   *
   * @param {string} name - Cookie name.
   * @returns {string|null} Decoded cookie value if found, otherwise null.
   */
export const getCookieValue = (name) => {
  // Example of cookie: "email=user@test.com; voucher=DISCOUNT50; ..."
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)

  // If there are 2 parts, it means the cookie exists.
  if (parts.length === 2) {
    try {
      return decodeURIComponent(parts.pop().split(';').shift())
    } catch {
      return null
    }
  }
  return null
}
